(ns modal.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::open symbol?)
(s/def ::close symbol?)
(s/def ::modal-dsl (s/keys :opt-un [::open
                                    ::close]))

(s/def ::view-symbol symbol?)
(s/def ::modal (s/keys :req-un [::visible?
                                ::view-symbol]))
